import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import moment from 'moment';
import React, { lazy, useState } from 'react';
import { developerRequestColumns as columns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Link = lazy(() => import(`globalcomponents/UI/Link`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`);
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const DeveloperRequest = ({ list, handleDeletePermissionRequest, handleAcceptPermissionRequest, callback, i18n }) => {
  const [ModalListObject, setModalListObject] = useState(null);

  const generateRows = () => {
    const updatedList = list?.map((item) => {
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].id === 'description') {
          item.description = item.url ? (
            <Link href={window.location.origin + item.url.replace('.', '')}>{item.description}</Link>
          ) : (
            item.description
          );
          item.date = item.date ? moment(item.date).format('MM/DD/YYYY hh:mm:ss') : '';
        }
        if (columns[i].id === 'date') {
          item.date = item.date ? moment(item.date).format('MM/DD/YYYY hh:mm:ss') : '';
        }
      }

      return item;
    });
    return updatedList;
  };

  const getConfirmationModal = ({ onConfirm, confirmLabel }) => (
    <div className="deleteParent">
      <div className="imageSection">
        <SvgIcon src={mediaUrls.confirmIcon} alt="Are you sure" />
      </div>
      <h2>{i18n.t('common.sureConfirm')}</h2>
      <div className="deletePopupBtn">
        <div className="cancelBtn">
          <Button label={i18n.t('common.cancel')} type="reset" onClick={() => setModalListObject(null)} />
        </div>
        <div className="deletebtn">
          <Button
            label={confirmLabel}
            onClick={() => {
              onConfirm();
              setModalListObject(null);
            }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'date', order: 'desc' }}
        title=""
        columns={[...columns]}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        noPagination
        actions={[
          {
            icon: (row) => {
              return (
                <Icon
                  src={mediaUrls?.tickIcon}
                  onClick={() => {
                    setModalListObject({
                      content: () =>
                        getConfirmationModal({
                          confirmLabel: i18n.t('common.acceptPopup'),
                          onConfirm: () =>
                            handleAcceptPermissionRequest({
                              apiId: 'acceptPermissionRequest',
                              data: { data: { id: row?.id } },
                              callback,
                            }),
                        }),
                    });
                  }}
                />
              );
            },
          },
          {
            icon: (row) => {
              return (
                <Icon
                  src={mediaUrls?.deleteIcon}
                  onClick={() => {
                    setModalListObject({
                      content: () =>
                        getConfirmationModal({
                          confirmLabel: i18n.t('common.deletePopup'),
                          onConfirm: () =>
                            handleDeletePermissionRequest({
                              apiId: 'deleteAlert',
                              data: { data: { id: row?.id } },
                              callback,
                            }),
                        }),
                    });
                  }}
                />
              );
            },
          },
        ]}
        i18n={i18n}
      />
      {ModalListObject && (
        <Modal.default open={!!ModalListObject} setOpen={() => setModalListObject(null)} data={ModalListObject} deletePopup />
      )}
    </>
  );
};

export default DeveloperRequest;

DeveloperRequest.defaultProps = {};
